import { useFormState } from 'react-final-form';
var FormStateWrapper = function (_a) {
    var children = _a.children;
    var state = useFormState();
    return children(state);
};
export default FormStateWrapper;
